import {clearCards} from '../index-info/list';

export const toggleLegendItems = () => {
  let lastZoom = window.fireMap.getZoom();
  const legendZoomHandler = e => {
    // Get the current zoom
    const zoom = window.fireMap.getZoom();
    // Show hotspots only when close
    // const hotspots = document.querySelector('.l-item.hotspot');
    const perimeters = document.querySelector('.l-item.fire-perimeter');
    if (zoom < 6) {
      // hotspots.style.display = 'none';
      perimeters.style.display = 'none';
    } else {
      // hotspots.style.display = 'flex';
      perimeters.style.display = 'flex';
    }
    // Show hexes only when far
    // const hexagon = document.querySelector('.l-item.hexagon');
    // if (zoom > 7) {
    //   hexagon.style.display = 'none';
    // } else {
    //   hexagon.style.display = 'flex';
    // }
    // remove rfw
    // const rfw = document.querySelector('.l-item.rfw');
    // if (zoom > 7.5) {
    //   rfw.style.display = 'none';
    // } else {
    //   rfw.style.display = 'flex';
    // }
    // remove aqi
    // const aqi = document.querySelector('.l-item.aqi');
    // if (zoom > 9) {
    //   aqi.style.display = 'none';
    // } else {
    //   aqi.style.display = 'flex';
    // }
    // Unselect any clicked fires when zooming back out to a far away view
    if (zoom <= lastZoom && lastZoom < 7.5) {
      if (e) {
        if (e.originalEvent) {
          clearCards();
        }
      }
    }
    // Update the global storing the current zoom
    lastZoom = zoom;
  }
  // Hook the event
  window.fireMap.on('zoom', legendZoomHandler);
  // Fire it one first time
  legendZoomHandler();
};
